import { render, staticRenderFns } from "./paySucceed.vue?vue&type=template&id=7a120b46&scoped=true"
import script from "./paySucceed.vue?vue&type=script&lang=js"
export * from "./paySucceed.vue?vue&type=script&lang=js"
import style0 from "./paySucceed.vue?vue&type=style&index=0&id=7a120b46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a120b46",
  null
  
)

export default component.exports